module.exports = __webpack_public_path__ + "static/media/she_is_not_heard.5e135ace.mp4";